import { render } from "./MemberApplicationTabDataPendidikan.vue?vue&type=template&id=3b30c854&scoped=true"
import script from "./MemberApplicationTabDataPendidikan.vue?vue&type=script&lang=js"
export * from "./MemberApplicationTabDataPendidikan.vue?vue&type=script&lang=js"

import "./MemberApplicationTabDataPendidikan.vue?vue&type=style&index=0&id=3b30c854&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b30c854"]])

export default __exports__